import { useState, useEffect, useContext } from 'react';
import useStore from '@/store/main/action';
import { useNavigate } from 'react-router';
import { API_URL } from '@/constants';
import { simpleFetch } from '@/utils/simpleFetch';
import { AuthContext } from '@panamod/react-utils';

interface FetchPinResponse {
    pin: boolean
}

export interface Pin {
    pin1: string;
    pin2: string;
    pin3: string;
    pin4: string;
}

const usePin = () => {
    const navigate = useNavigate();

    const { setSurveyToken, surveytoken } = useStore();
    const { userData } = useContext(AuthContext);
    
    const [pinValue, setPinValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(0);

    const handleGoBack = () => {
        navigate(`encuestas/${surveytoken}`);
    };

    /* 
		status: 
		0 - none
		2 - done
		3 - not found 
		4 - error
    */
    const handleError = () => {
        setPinValue('');
    };

    const handleCheckPin = async () => {
        setLoading(true);
        

        if (pinValue.length >= 4) {
            const helperPin = pinValue.substring(0, 4);
            const datos = {
                cPin: helperPin,
                nUsuario: userData?.nUsuario,
            };
            
            const response = await simpleFetch<FetchPinResponse>({
                url: `${API_URL}v1/Valida/Pin`,
                method: 'POST',
                params: datos,
            });

            if (!response.success) {
                handleError();
                setStatus(4);
            } else if (response.success && response.data.pin) {
                setStatus(2);
                setSurveyToken(null);
            } else {
                setStatus(3);
                handleError();
            }
            setLoading(false);
        }
    };

    const handlePinValue = (value: string) => {
        console.log(value)
        setPinValue(value);
    };

    useEffect(() => {
        if (pinValue.length === 4) {
            handleCheckPin();
        }
    }, [pinValue]);

    return {
        handlePinValue,
        pinValue,
        status,
        surveytoken,
        setPinValue,
        handleGoBack,
        loading,
    };
};

export default usePin;
